import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const REVIEWS = [
	{ quote: "We went from struggling to fill classes to a waitlist in two sessions. SchoolXpert360's admission system is the real deal.", name: "Dr. Meera Nair", role: "Principal, K-12 School, Kochi" },
	{ quote: "Our preschool launched with a full batch. The 50-admission assurance wasn't just a tagline — they delivered.", name: "Anil Verma", role: "Founder, Preschool, Jaipur" },
	{ quote: "The catchment-area marketing brought us qualified parent enquiries at half our earlier cost per lead.", name: "Sana Qureshi", role: "Director, CBSE School, Hyderabad" },
];

export function Testimonials() {
	return (
		<section className="py-16 md:py-24">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="max-w-2xl mb-12">
					<p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 dark:text-emerald-400">Results</p>
					<h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white">
						Schools that chose growth
					</h2>
				</div>
				<div className="grid gap-6 md:grid-cols-3">
					{REVIEWS.map((r, i) => (
						<motion.div key={r.name}
							initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
							transition={{ delay: i * 0.08 }}
							className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-6 flex flex-col"
						>
							<Quote className="h-8 w-8 text-emerald-500/30" />
							<div className="mt-2 flex gap-0.5 text-amber-500">
								{[...Array(5)].map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}
							</div>
							<p className="mt-3 text-slate-700 dark:text-slate-300 flex-1">"{r.quote}"</p>
							<div className="mt-5">
								<p className="font-semibold text-slate-900 dark:text-white">{r.name}</p>
								<p className="text-sm text-slate-500 dark:text-slate-400">{r.role}</p>
							</div>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
}
